import React from 'react';

import { Text } from '~/src/dash/publicaUI';

interface ISearchResultsTextProps {
  numRowsDisplayed: number; // number of rows currently shown
  numTotalRows: number; // number of total rows available
}

// this is an accompanying component for TextInput search
// currently non-customizable in order to match
export const SearchResultsText = ({ numRowsDisplayed, numTotalRows }: ISearchResultsTextProps) => {
  return (
    <Text
      extraSmall
      muted
      style={{ whiteSpace: 'nowrap' }}
      tKey='ShowingNumOfTotalResults'
      tProps={{ number: numRowsDisplayed, total: numTotalRows }}
    />
  );
};
